import React from 'react';
import { Control } from 'react-hook-form';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

import { ICheckList } from './schema';
import Steps from './Steps';

interface IProps {
  control: Control<ICheckList>;
  onSubmit: React.MouseEventHandler;
  submitText?: string;
  showUndo?: boolean;
  onUndo: React.MouseEventHandler;
}

const CheckListFormView: React.FC<IProps> = ({
  control,
  onSubmit,
  submitText,
  onUndo,
  showUndo,
}) => (
  <>
    <FormField
      name="name"
      control={control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Nome</FormLabel>
          <FormControl>
            <Input {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />

    <Steps control={control} />
    <div className="flex justify-end gap-4">
      {showUndo && (
        <Button variant="outline" onClick={onUndo}>
          Desfazer
        </Button>
      )}
      <Button onClick={onSubmit}>{submitText ?? 'Submit'}</Button>
    </div>
  </>
);

export default CheckListFormView;
